<template>
    <div class="nursing-care">
        <div class="chart-row">
            <div class="chart-card w-1-2">
                <p class="chart-card-tit">{{ graphTitle }}</p>
                <disease-chart :option="graphOption" height="360px" />
            </div>
            <div class="chart-card w-1-2">
                <p class="chart-card-tit">{{ pieTitle }}</p>
                <disease-chart :option="pieOption" height="360px" />
            </div>
        </div>
    </div>
</template>

<script>
import DiseaseChart from './disease_chart.vue';
import nursingCareData from '../mock/nursingCare.json';

function buildGraphOption(graph) {
    const categories = graph.categories || [];
    const nodes = graph.nodes || [];
    const links = graph.links || [];
    return {
        tooltip: { trigger: 'item' },
        legend: {
            data: categories.map((item) => item.name),
            bottom: 0,
            textStyle: { color: '#5A6779', fontSize: 11 },
        },
        series: [
            {
                type: 'graph',
                layout: 'force',
                roam: true,
                draggable: true,
                legendHoverLink: false,
                categories,
                data: nodes,
                links,
                label: {
                    show: true,
                    color: '#333',
                    fontSize: 11,
                },
                lineStyle: {
                    color: 'source',
                    curveness: 0.15,
                    opacity: 0.6,
                },
                force: {
                    repulsion: 260,
                    edgeLength: [40, 110],
                    gravity: 0.08,
                },
                emphasis: {
                    focus: 'adjacency',
                    lineStyle: { width: 3 },
                },
            },
        ],
    };
}

function buildPieOption(list) {
    return {
        tooltip: {
            trigger: 'item',
            formatter: '{b}: {c} ({d}%)',
        },
        legend: {
            bottom: 0,
            textStyle: { color: '#5A6779', fontSize: 11 },
        },
        series: [
            {
                type: 'pie',
                // 实心饼图：不设 radius 数组，使用默认色值
                radius: '58%',
                center: ['50%', '46%'],
                data: list || [],
                label: {
                    formatter: '{b}\n{d}%',
                    fontSize: 12,
                    color: '#333',
                },
                labelLine: {
                    length: 10,
                    length2: 8,
                },
                emphasis: {
                    itemStyle: {
                        shadowBlur: 8,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0,0,0,0.15)',
                    },
                },
            },
        ],
    };
}

export default {
    name: 'NursingCare',
    components: {
        DiseaseChart,
    },
    data() {
        return {
            chartData: nursingCareData,
        };
    },
    computed: {
        graphTitle() {
            return (this.chartData.graph && this.chartData.graph.title) || '知识图谱';
        },
        pieTitle() {
            return (this.chartData.pie && this.chartData.pie.title) || '护理调养占比';
        },
        graphOption() {
            return buildGraphOption(this.chartData.graph || { categories: [], nodes: [], links: [] });
        },
        pieOption() {
            const list = (this.chartData.pie && this.chartData.pie.list) || [];
            return buildPieOption(list);
        },
    },
};
</script>

<style lang="less" scoped>
.nursing-care {
    .chart-row {
        display: flex;
        gap: 16px;
        align-items: stretch;
    }

    .chart-card {
        min-width: 0;
        background: #fff;
        border: 1px solid #E8EEF8;
        border-radius: 10px;
        padding: 12px 14px 16px;
        box-sizing: border-box;

        &.w-1-2 {
            flex: 1 1 0;
        }
    }

    .chart-card-tit {
        margin: 0 0 8px;
        font-size: 14px;
        font-weight: bold;
        color: #0C55AA;
        line-height: 20px;
    }
}
</style>
